<template>
    <i :class="getName" :style="`color: ` + getColor"></i>
</template>

<script>
export default {
    props: ["type"],
    data() {
        return{
            iconFile: {
                "pdf": "fas fa-file-pdf",
                "docx": "fas fa-file-word",
                "doc": "fas fa-file-word",
                "mp4": "fas fa-file-video",
                "pptx": "fas fa-file-powerpoint",
                "ppt": "fas fa-file-powerpoint",
                "xlsx": "fas fa-file-excel",
                "xls": "fas fa-file-excel"
            },
            colorFile: {
                "pdf": "red",
                "docx": "blue",
                "doc": "blue",
                "mp4": "grey",
                "pptx": "#a4a4a4",
                "ppt": "#a4a4a4",
                "xlsx": "green",
                "xls": "green"
            }
        };
    },
    computed: {
        getName(){
            return this.iconFile[this.type]
        },
        getColor(){
            return this.colorFile[this.type]
        }
    }
}
</script>